import { API } from "../../../utils";

export const getRACTDetailsApi = async () => {
  const res = await API.get("ract");
  return res.data;
};

export const updateRACTDetailsApi = async (id, payload) => {
  const res = await API.put(`ract/${id}`, payload);
  return res.data;
};

export const getRACTMembers = async (query, pagination) => {
  const { pageIndex = 1, pageSize = 50 } = pagination ?? {};
  const res = await API.get(
    `ract/members?page=${pageIndex}&per_page=${pageSize}`,
    query,
  );
  return res.data;
};

export const addRACTMember = async (payload) => {
  const res = await API.post("ract/members", payload);
  return res.data;
};

export const importRACTMembers = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await API.post("ract/members/import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteRACTMembers = async (payload) => {
  const res = await API.delete("ract/members", { data: payload });
  return res.data;
};

export const downloadRACTSample = async () => {
  const res = await API.get("ract/sample/download", {
    responseType: "blob",
  });
  return res;
};

export const downloadRACTMembers = async () => {
  const res = await API.get("ract/members/download", {
    responseType: "blob",
  });
  return res;
};
